'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var FilterDropdown = function (_React$Component) {
  _inherits(FilterDropdown, _React$Component);
  function FilterDropdown() {
    _classCallCheck(this, FilterDropdown);
    return _possibleConstructorReturn(this, (FilterDropdown.__proto__ || Object.getPrototypeOf(FilterDropdown)).apply(this, arguments));
  }
  _createClass(FilterDropdown, [{
    key: 'handleChange',
    value: function handleChange(event) {
      if (event.target.value === 'remove_filter') {
        this.props.filter.remove(this.props.attribute);
      } else {
        this.props.filter.update(this.props.attribute, event.target.value);
      }
    }
  }, {
    key: 'generateOptions',
    value: function generateOptions() {
      var _props = this.props,
        attribute = _props.attribute,
        items = _props.items;
      var options = this.props.options.length === 0 ? (0, _lodash.uniqWith)(items.reduce(function (acc, item) {
        var filters = [];
        if (Array.isArray(item[attribute])) {
          item[attribute].map(function (filter) {
            return filters.push({
              value: filter,
              text: (0, _lodash.startCase)(filter)
            });
          });
        } else {
          filters.push({
            value: item[attribute],
            text: (0, _lodash.startCase)(item[attribute])
          });
        }
        return acc.concat(filters);
      }, []), _lodash.isEqual) : this.props.options;
      return options;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var options = this.generateOptions();
      return _react2.default.createElement('div', {
        className: 'filter__dropdown ' + this.props.className
      }, _react2.default.createElement('label', {
        htmlFor: 'filter-dropdown-' + this.props.attribute
      }, this.props.label), _react2.default.createElement('select', {
        onChange: function onChange(event) {
          _this2.handleChange(event);
        },
        id: 'filter-dropdown-' + this.props.attribute
      }, _react2.default.createElement('option', {
        value: 'remove_filter'
      }, this.props.defaultOption), options.map(function (option) {
        return _react2.default.createElement('option', {
          value: option.value
        }, option.text);
      })));
    }
  }]);
  return FilterDropdown;
}(_react2.default.Component);
FilterDropdown.defaultProps = {
  className: '',
  defaultOption: 'None',
  label: '',
  options: []
};
FilterDropdown.propTypes = {
  attribute: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  defaultOption: _propTypes2.default.string,
  filter: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  }))
};
exports.default = FilterDropdown;